import { FetchContext } from '../fetch-context';
import { JudgingQuestion } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const upsertJudgingQuestions: (
  fetchContext: FetchContext,
  awardId: number,
  judgingQuestions: JudgingQuestion[],
  accessToken?: string,
) => Promise<number[]> = (fetchContext, awardId, judgingQuestions, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/awards/${awardId}/judging-questions`,
  {
    method: 'PUT',
    body: JSON.stringify(judgingQuestions),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<number[]>(fetchContext.errorStore, response, 'upsert judging questions'));
